import { render, staticRenderFns } from "./SupplierPurchaseSummary.vue?vue&type=template&id=0b7f80e2&scoped=true"
import script from "./SupplierPurchaseSummary.vue?vue&type=script&lang=js"
export * from "./SupplierPurchaseSummary.vue?vue&type=script&lang=js"
import style0 from "./SupplierPurchaseSummary.vue?vue&type=style&index=0&id=0b7f80e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f80e2",
  null
  
)

export default component.exports